import { parse, isValid } from 'date-fns';

import { ISO_FORMAT } from './constants';

export const getDate = (date: string | Date, dateFormat = ISO_FORMAT) => {
  if (!date) return undefined;
  if (date instanceof Date) return date;

  const parsedDate = parse(date, dateFormat, new Date());
  return isValid(parsedDate) ? parsedDate : undefined;
};
